module.exports = __webpack_public_path__ + "media/images/svgs/sub_menu/person-e5208ae039ce40d79ae741e8a380eb2a.svg";